import { Route, Routes, BrowserRouter } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import Login from "./Pages/LogInPage/Login";
import SignUp from "./Pages/SignUp/SignUp";
import TherapyType from "./Pages/GettingStartedPages/TherapyType/TherapyType";
import Difficulties from "./Pages/GettingStartedPages/Difficulties/Difficulties";
import Gender from "./Pages/GettingStartedPages/Gender/Gender";
import Age from "./Pages/GettingStartedPages/Age/Age";
import { UserAuthContextProvider } from "./Context/UseAuthContext";
import ProtectedRoute from "./ProjectedRoute/ProtectedRoute";
import Dashboad from "./components/depreliefChart/Dashboad/Dashboad";
import SideBar from "./components/depreliefChart/SideBar/SideBar";
import Chat from "./components/depreliefChart/Chat/Chat";
import ProtectedRoute1 from "./ProjectedRoute/ProtectedRoute1";
import Emergency from "./Pages/Emergency/Emergency";

function App() {
  return (
    <BrowserRouter>
      <UserAuthContextProvider>
        <Routes>
          <Route path="/" exact element={<HomePage />} />
          <Route path="/login" exact element={<Login />} />
          <Route path="/signup" exact element={<SignUp />} />
          <Route path="/start" exact element={<TherapyType />} />
          <Route path="/side" eaxct element={<SideBar />} />
          <Route
            path="/difficulties"
            exact
            element={
              <ProtectedRoute>
                <Difficulties />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gender"
            exact
            element={
              <ProtectedRoute>
                <Gender />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dash"
            exact
            element={
              <ProtectedRoute1>
                <Dashboad />
              </ProtectedRoute1>
            }
          />
          <Route path="/dash/:roomId" exact element={<Chat />} />
          <Route path="/age" exact element={<Age />} />
          <Route path="/emergency" exact element={<Emergency />} />
        </Routes>
      </UserAuthContextProvider>
    </BrowserRouter>
  );
}

export default App;
